import { colors } from '@alixpartners/ui-components';

export const iconColor = colors.grey400;
export const cardColorDefault = colors.grey400;
